const TOGGLE_FLOW_TREE_LOADING = "TOGGLE_FLOW_TREE_LOADING";
const TOGGLE_LAYOUT_TREE_LOADING = "TOGGLE_LAYOUT_TREE_LOADING";
const SET_FLOW_LOADING_EXCLUDE = "SET_FLOW_LOADING_EXCLUDE";
const ADD_FLOW_FOLDER_LOADING = "ADD_FLOW_FOLDER_LOADING";
const REMOVE_FLOW_FOLDER_LOADING = "REMOVE_FLOW_FOLDER_LOADING";

export const ToggleIsFlowTreeLoading = newValue => ({
    type: TOGGLE_FLOW_TREE_LOADING,
    isLoading: newValue,
});

export const SetIsFlowLoadingExcludes = newValue => ({
    type: SET_FLOW_LOADING_EXCLUDE,
    isFlowTreeLoadingExclude: newValue,
});

export const AddFlowFolderLoading = folderId => ({
    type: ADD_FLOW_FOLDER_LOADING,
    folderId,
});

export const RemoveFlowFolderLoading = folderId => ({
    type: REMOVE_FLOW_FOLDER_LOADING,
    folderId,
});

export const ToggleIsLayoutTreeLoading = newValue => ({
    type: TOGGLE_LAYOUT_TREE_LOADING,
    isLoading: newValue,
});
